<h1>{{ header }}</h1>
<i *ngIf="showCloseButton" class="iq-icon--close" iqCloseDialog></i>
